import { ANY } from '../../constants/building/availableCondos';
import React from 'react';
import { SearchBoxFilters } from 'components/Search/SearchInput/types';

export type AnyValue = { min: string; max: string };

export type SetFiltersValues = React.Dispatch<
  React.SetStateAction<FiltersValues>
>;
export type OnChangeFilters = (filters: FiltersValues) => void;

export const initialAny: AnyValue = {
  min: ANY,
  max: ANY,
};

export type PolygonPoint = { lat: number; lng: number };
export type PolygonPath = PolygonPoint[];
export type PolygonFilter = PolygonPath[];

export type ListingTypeTypes = {
  preConstruction: boolean;
  newConstruction: boolean;
  forRent: boolean;
  forSale: boolean;
  foreclosures: boolean;
  shortSales: boolean;
  existingCondos: boolean;
  comingSoon: boolean;
  sold: boolean | string;
};

export type ListingTypeKeys = keyof ListingTypeTypes;

export type FilterCoordinates = {
  southWest: PolygonPoint;
  northEast: PolygonPoint;
};

export type FiltersValues = ListingTypeTypes & {
  searchBoxFilters: SearchBoxFilters;
  anyPrice: AnyValue;
  anyBeds: AnyValue;
  baths: string;
  parkingPlaces: string;
  propertyTypeCode?: string;
  sqft: AnyValue;
  yearBuild: AnyValue;
  daysOnCbb: string;
  closedAt: string;
  petFriendly: boolean;
  bitcoin: boolean;
  sellerFinancing: boolean;
  shortTermRent: boolean;
  notShortTermRent: boolean;
  furnished: boolean;
  unfurnished: boolean;
  intracoastalView: boolean;
  oceanView: boolean;
  skylineView: boolean;
  beachfront: boolean;
  oceanfront: boolean;
  wfAny: boolean;
  penthouse?: boolean;
  keyWords: string;
  showPendingListings: boolean;
  maxHOA: string;
  corner: boolean;
  floor: AnyValue;
  priceSqFt: AnyValue;
  unitNumberRegex: string;
  unitsInBuilding: AnyValue;
  rentalInvestments: boolean;
  lowDownPayment: boolean;
  shortTermRentTerms: string[];
  notShortTermRentTerms: string[];
  secretSearch: string;
  coordinates?: FilterCoordinates;
  polygons?: PolygonFilter;
  sortOption?: string;
  page?: string;
  ppc?: string;
  att?: string;
  sw?: string;
  ne?: string;
  z?: string;
  poly?: string;
  isLink?: boolean;
};

export type PropertyType = 'sale' | 'rent';

export type ListingsCountsType = { [index in ListingTypeKeys]: number };
